import { useEffect, useRef, useState } from "react";
import { User, Settings, LogOut, ChevronDown } from "lucide-react";
import { useNavigate } from "react-router-dom";
import "./common.css";


export default function UserMenu({ avatar, name, role, onLogout }) {
  const [open, setOpen] = useState(false);
  const ref = useRef(null);
  const navigate = useNavigate();

  useEffect(() => {
    function handleClickOutside(e) {
      if (ref.current && !ref.current.contains(e.target)) {
        setOpen(false);
      }
    }
    document.addEventListener("mousedown", handleClickOutside);
    return () => document.removeEventListener("mousedown", handleClickOutside);
  }, []);

  return (
    <div className="userMenu" ref={ref}>
      <button
        type="button"
        className={`userPill ${open ? "active" : ""}`}
        onClick={() => setOpen((v) => !v)}
      >
        <img className="userAvatar" src={avatar} alt={name} />

        <div className="userMeta">
          <div className="userName">{name}</div>
          <div className="userRole">{role}</div>
        </div>

        <ChevronDown
          size={16}
          className={`chevron ${open ? "rotate" : ""}`}
        />
      </button>

      {open && (
        <div className="userDropdown">
          <button
            className="userItem"
            onClick={() => {
              setOpen(false);
              navigate("/profile");
            }}
          >
            <User size={16} />
            Profil
          </button>

          <button className="userItem">
            <Settings size={16} />
            Paramètres
          </button>

          <div className="userDivider" />

          <button className="userItem danger" onClick={onLogout}>
            <LogOut size={16} />
            Déconnexion
          </button>
        </div>
      )}
    </div>
  );
}
